import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import it from './locales/it.json'
import en from './locales/en.json'

function detectInitialLanguage() {
  if (typeof window === 'undefined') return 'it'

  let stored
  try {
    stored = localStorage.getItem('lng')
  } catch {
    stored = null
  }

  const browserLang = (() => {
    if (typeof navigator === 'undefined') return 'en'
    const raw = (navigator.languages && navigator.languages[0]) || navigator.language || 'en'
    return String(raw).toLowerCase().startsWith('it') ? 'it' : 'en'
  })()

  if (stored && (stored === 'it' || stored === 'en')) {
    return stored
  }

  return browserLang
}

i18n
  .use(initReactI18next)
  .init({
    resources: {
      it: { translation: it },
      en: { translation: en }
    },
    lng: detectInitialLanguage(),
    fallbackLng: 'it',
    supportedLngs: ['it', 'en'],
    interpolation: { escapeValue: false },
    returnEmptyString: false
  })

i18n.on('languageChanged', (lng) => {
  try {
    localStorage.setItem('lng', lng)
  } catch {
    // ignore
  }
})

export default i18n
